import React, { useState, useMemo } from "react";
import ConfirmationPopup from "../../../common/components/confirmation-popup/confirmation-popup";
import { massDeleteLeads } from "../../../api/lead";
import { AlertComponent } from "../../../common/components";
import { useSetLoading } from "../../../common/hooks/appearance";
import { MassDeleteProps } from "./action-types";
import WarningIcon from '@mui/icons-material/Warning';
import { Typography, Box } from '@mui/material';

const MassDelete: React.FC<MassDeleteProps> = ({
    leadsIds,
    setSelectedLeadsMap,
    isOpen,
    setMenuItems,
    selectedActions,
    setSelectedActions,
    fetchLeads,
    selectedLeadActionScope,
    setselectedLeadActionScope,
    totalRecords,
    handleMassActionMenuClose
}) => {
    const [alertMessage, setAlertMessage] = useState<string>("");
    const [alertType, setAlertType] = useState<"success" | "error">("success");
    const [alertOpen, setAlertOpen] = useState<boolean>(false);
    const [isLoading, setLoading] = useState<boolean>(false);  // ✅ Loading state

    const handleClose = () => {
        setMenuItems((prevItems) =>
            prevItems.map((item) =>
                item.value === selectedActions ? { ...item, isOpen: !item.isOpen } : item
            )
        );
        handleMassActionMenuClose()
    };

    const handleDelete = async () => {
        setLoading(true);
        try {
            const response = await massDeleteLeads({ 'leadsIds': leadsIds });
            if (response?.status === 204) {
                setAlertMessage(`${leadsIds?.length === 1 ? "Record" : "Record(s)"} archived successfully.`);
                setAlertType("success");
                setSelectedLeadsMap({})
                setselectedLeadActionScope("")
                fetchLeads();
            }
        } catch (error: any) {
            setAlertMessage(error?.response?.data?.message ||  "An error occurred while saving the lead.");
            setAlertType("error");
            setAlertOpen(true);
        } finally {
            setLoading(false);
            setAlertOpen(true);
            handleClose()
        }
    };

    const showLoading = useMemo(() => isLoading, [isLoading]);
    useSetLoading(showLoading);
    return (
        <>
            {/* {loading && <Loader />}   */}

            <ConfirmationPopup
                open={isOpen}
                title={(leadsIds?.length === 1) ? "Archive Lead" : "Archive Leads"}
                note={
                    <Box display="flex" alignItems="center" gap={1}>
                        <WarningIcon color="warning" />
                        <Typography variant="body2">
                            Are you sure you want to archive{' '}
                            {
                                leadsIds?.length === 1 ? (
                                    <strong>the selected lead</strong>
                                ) : (
                                    <strong>the selected lead(s)</strong>
                                )
                            }
                            ? This action cannot be undone.
                        </Typography>
                    </Box>
                }
                buttonText="Archive"
                onCancel={handleClose}
                onOkay={handleDelete}
            />

            <AlertComponent
                message={alertMessage}
                type={alertType}
                open={alertOpen}
                onClose={() => setAlertOpen(false)}
            />
        </>
    );
};

export default MassDelete;